<template>
    <div class="tab-detail">
        <div class="header">
            <div class="title">{{ $t("message.trendyolStoreIntegrationDetail") }}</div>
            <div class="subtitle">{{$t("message.configureTrendyolStoreIntegrationDetail")}}</div>
        </div>

        <a-form>
            <div class="form-wrapper">
                <div class="input-wrapper">
                    <label>{{ $t("message.channelName") }}</label>
                    <a-input
                        :placeholder="$t('message.channelName')"
                        v-model="clone.name"
                        v-validate="'required'"
                        name="channelName"
                    />
                </div>
                <div class="input-wrapper">
                    <label>Trendyol Satıcı ID</label>
                    <a-input v-model="clone.payload.sellerId" placeholder="Trendyol Satıcı ID" />
                </div>
                <div class="input-wrapper">
                    <label>Trendyol API Key</label>
                    <a-input v-model="clone.payload.apiKey" placeholder="Trendyol API Key" />
                </div>
                <div class="input-wrapper">
                    <label>Trendyol API Secret Key</label>
                    <a-input v-model="clone.payload.apiSecretKey" placeholder="Trendyol API Secret Key" />
                </div>
            </div>
        </a-form>
        <div class="form-footer mt-5">
            <div class="actions">
                <a-button class="pr-confirm-btn" @click="handleSave" type="primary" :disabled="loading">
                    {{ $t("message.update") }}
                </a-button>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import _ from "lodash";
import log2 from "../../../../../utils/log2";
import { mapActions, mapState } from "vuex";

const log = log2("TrendyolChannelUpdateForm.vue");
export default Vue.extend({
    name: "TrendyolChannelUpdateForm",
    components: {},
    props: {
        value: {
            required: true,
        },
    },
    data() {
        return {
            clone: _.cloneDeep(this.value),
            loading: false,
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
        }),
    },
    methods: {
        ...mapActions({
            updateChannel: "channel/updateChannel",
            listChannels: "channel/listChannels",
        }),
        handleSave() {
            const isValid = true;
            if (isValid) {
                const payload = this.clone;
                this.loading = true;
                this.updateChannel(payload)
                    .then(() => {
                        this.listChannels();
                        this.$message.success("Channel updated successfully");
                        this.$emit("input", this.clone);
                        this.clone = _.cloneDeep(this.clone);
                    })
                    .catch((err) => {
                        console.error(err);
                        this.$message.error("Failed to update channel");
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
    },
    mounted() {},
    watch: {
        value: {
            handler: function (val) {
                const isChanged = !_.isEqual(val, this.clone);
                if (isChanged) {
                    log("value changed=>", val);
                    this.clone = _.cloneDeep(val);
                }
            },
            deep: true,
        },
    },
});
</script>

<style scoped lang="scss">
.tab-detail {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px;

    .form-wrapper {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .header {
        display: flex;
        justify-content: space-between;
        padding-bottom: 10px;

        border-bottom: 1px solid var(--color-border-default);

        .title {
            font-size: 18px;
            font-weight: 700;
            color: var(--color-text-strong-default);
        }

        .subtitle {
            font-size: 14px;
            color: var(--color-text-strong-default);
        }
    }
}
</style>
